import type {SubscriptionPriceProduct, SubscriptionType, SubscriptionProductType} from "@/models";
import type {BillingPeriod} from "@/components/checkout/PricingCard.tsx";

export interface PackageConfig {
  type: SubscriptionType;
  period: BillingPeriod;
  name: string;
  subtitle: string;
  shortDescription?: string;
  features: string[];
  idealFor?: string;
  popular?: boolean;
}

// Package configurations mapped by subscription type
export const PRICING_PACKAGES: PackageConfig[] = [
  // ============================================
  // Paket 1: Trade (SWINGTRADES_LONGTERM)
  // ============================================
  {
    type: 'SWINGTRADES_LONGTERM_1M',
    period: '1m',
    name: 'Trade',
    subtitle: 'Für aktive Anleger, die klare Setups UND aktiver sein wollen.',
    shortDescription: 'Konkret. Umsetzbar. Optimal für alle, die dynamischer handeln und gleichzeitig ihre Fähigkeiten ausbauen möchten.',
    features: [
      'Langfristige Tradingideen (Buy & Hold)',
      'Klare Swing-Tradingideen',
      'Zielzonen & Ausstiegsbereiche',
      'Monatliche schriftliche Marktanalyse',
      'Campus-Tools & Marktorientierung (Fear & Greed Index, Index-Übersicht, Wirtschafts- & Earnings-Kalender)',
      'Kostenloser Schulungs-Bereich',
      'Onlinekurs „Börsen 1x1" inklusive',
      'Individuelles Onboarding damit du dich gleich zurechtfindest',
      'regelmäßige Q&A Videos',],
    idealFor: 'Alle, die aktiver handeln und gleichzeitig trotzdem langfristig investieren wollen'
  },
  {
    type: 'SWINGTRADES_LONGTERM_6M',
    period: '6m',
    name: 'Trade',
    subtitle: 'Für aktive Anleger, die klare Setups UND aktiver sein wollen.',
    shortDescription: 'Konkret. Umsetzbar. Optimal für alle, die dynamischer handeln und gleichzeitig ihre Fähigkeiten ausbauen möchten.',
    features: [
      'Langfristige Tradingideen (Buy & Hold)',
      'Klare Swing-Tradingideen',
      'Zielzonen & Ausstiegsbereiche',
      'Monatliche schriftliche Marktanalyse',
      'Campus-Tools & Marktorientierung (Fear & Greed Index, Index-Übersicht, Wirtschafts- & Earnings-Kalender)',
      'Kostenloser Schulungs-Bereich',
      'Onlinekurs „Börsen 1x1" inklusive',
      'Individuelles Onboarding damit du dich gleich zurechtfindest',
      'regelmäßige Q&A Videos',],
    idealFor: 'Alle, die aktiver handeln und gleichzeitig trotzdem langfristig investieren wollen'
  },
  {
    type: 'SWINGTRADES_LONGTERM_12M',
    period: '12m',
    name: 'Trade',
    subtitle: 'Für aktive Anleger, die klare Setups UND aktiver sein wollen.',
    shortDescription: 'Konkret. Umsetzbar. Optimal für alle, die dynamischer handeln und gleichzeitig ihre Fähigkeiten ausbauen möchten.',
    features: [
      'Langfristige Tradingideen (Buy & Hold)',
      'Klare Swing-Tradingideen',
      'Zielzonen & Ausstiegsbereiche',
      'Monatliche schriftliche Marktanalyse',
      'Campus-Tools & Marktorientierung (Fear & Greed Index, Index-Übersicht, Wirtschafts- & Earnings-Kalender)',
      'Kostenloser Schulungs-Bereich',
      'Onlinekurs „Börsen 1x1" inklusive',
      'Individuelles Onboarding damit du dich gleich zurechtfindest',
      'regelmäßige Q&A Videos',],
    idealFor: 'Alle, die aktiver handeln und gleichzeitig trotzdem langfristig investieren wollen'
  },

  // ============================================
  // Paket 2: Cashflow (ALL)
  // ============================================
  {
    type: 'ALL_1M',
    period: '1m',
    name: 'Cashflow',
    subtitle: 'Für Anleger, die monatliche Einnahmen und maximale Orientierung wollen.',
    shortDescription: 'Dieses Paket kombiniert alle Tradingideen, alle Tools, alle Strategien – inklusive Tradingideen der Strategie „Mieteinnahmen mit Aktien" für regelmäßige Cashflows.',
    features: [
      'Buy & Hold Tradingideen',
      'Swing-Trading Tradingideen',
      'Ca. 40+ Cashflow-Tradingideen pro Monat',
      'inkl. Kernstrategie-Tradingideen (Cash Secured Puts)',
      'inkl. Earnings Tradingideen',
      'inkl. Dashboard: „Geht durch / Wird eng / Eingebucht"',
      'Monatliche Marktanalyse',
      'Alle Campus-Tools',
      'Börsen 1x1 inklusive',
      'FinanzFlix inklusive',
      'Individuelles Onboarding damit du dich gleich zurechtfindest',
      'regelmäßige Q&A Videos',],
    idealFor: 'Alle, die planbare, wiederholbare monatliche Einnahmen wollen – und ein System, das ihnen Orientierung gibt.',
    popular: true
  },
  {
    type: 'ALL_6M',
    period: '6m',
    name: 'Cashflow',
    subtitle: 'Für Anleger, die monatliche Einnahmen und maximale Orientierung wollen.',
    shortDescription: 'Dieses Paket kombiniert alle Tradingideen, alle Tools, alle Strategien – inklusive Tradingideen der Strategie „Mieteinnahmen mit Aktien" für regelmäßige Cashflows.',
    features: [
      'Buy & Hold Tradingideen',
      'Swing-Trading Tradingideen',
      'Ca. 40+ Cashflow-Tradingideen pro Monat',
      'inkl. Kernstrategie-Tradingideen (Cash Secured Puts)',
      'inkl. Earnings Tradingideen',
      'inkl. Dashboard: „Geht durch / Wird eng / Eingebucht"',
      'Monatliche Marktanalyse',
      'Alle Campus-Tools',
      'Börsen 1x1 inklusive',
      'FinanzFlix inklusive',
      'Individuelles Onboarding damit du dich gleich zurechtfindest',
      'regelmäßige Q&A Videos',],
    idealFor: 'Alle, die planbare, wiederholbare monatliche Einnahmen wollen – und ein System, das ihnen Orientierung gibt.',
    popular: true
  },
  {
    type: 'ALL_12M',
    period: '12m',
    name: 'Cashflow',
    subtitle: 'Für Anleger, die monatliche Einnahmen und maximale Orientierung wollen.',
    shortDescription: 'Dieses Paket kombiniert alle Tradingideen, alle Tools, alle Strategien – inklusive Tradingideen der Strategie „Mieteinnahmen mit Aktien" für regelmäßige Cashflows.',
    features: [
      'Buy & Hold Tradingideen',
      'Swing-Trading Tradingideen',
      'Ca. 40+ Cashflow-Tradingideen pro Monat',
      'inkl. Kernstrategie-Tradingideen (Cash Secured Puts)',
      'inkl. Earnings Tradingideen',
      'inkl. Dashboard: „Geht durch / Wird eng / Eingebucht"',
      'Monatliche Marktanalyse',
      'Alle Campus-Tools',
      'Börsen 1x1 inklusive',
      'FinanzFlix inklusive',
      'Individuelles Onboarding damit du dich gleich zurechtfindest',
      'regelmäßige Q&A Videos',],
    idealFor: 'Alle, die planbare, wiederholbare monatliche Einnahmen wollen – und ein System, das ihnen Orientierung gibt.',
    popular: true
  },

  // ============================================
  // Paket 3: Daytrading (DAYTRADING)
  // ============================================
  {
    type: 'DAYTRADING_1M',
    period: '1m',
    name: 'Daytrading',
    subtitle: 'Für aktive Trader, die täglich am Markt agieren wollen.',
    shortDescription: 'Live-Daytrading-Sessions, Echtzeit-Analysen und direkter Austausch – für alle, die den Intraday-Handel systematisch angehen möchten.',
    features: [
      // 'Alle Inhalte aus dem Paket "Cashflow"',
      'Live-Daytrading-Sessions',
      'Echtzeit-Marktanalysen',
      'Intraday-Tradingideen',
      'Direkter Austausch während der Sessions',
      'Aufzeichnungen vergangener Sessions',
      'Individuelles Onboarding damit du dich gleich zurechtfindest'],
    idealFor: 'Erfahrene Trader, die täglich aktiv handeln und von Live-Analysen und Echtzeit-Setups profitieren wollen.'
  },
  {
    type: 'DAYTRADING_6M',
    period: '6m',
    name: 'Daytrading',
    subtitle: 'Für aktive Trader, die täglich am Markt agieren wollen.',
    shortDescription: 'Live-Daytrading-Sessions, Echtzeit-Analysen und direkter Austausch – für alle, die den Intraday-Handel systematisch angehen möchten.',
    features: [
      // 'Alle Inhalte aus dem Paket "Cashflow"',
      'Live-Daytrading-Sessions',
      'Echtzeit-Marktanalysen',
      'Intraday-Tradingideen',
      'Direkter Austausch während der Sessions',
      'Aufzeichnungen vergangener Sessions',
      'Individuelles Onboarding damit du dich gleich zurechtfindest',],
    idealFor: 'Erfahrene Trader, die täglich aktiv handeln und von Live-Analysen und Echtzeit-Setups profitieren wollen.'
  },
  {
    type: 'DAYTRADING_12M',
    period: '12m',
    name: 'Daytrading',
    subtitle: 'Für aktive Trader, die täglich am Markt agieren wollen.',
    shortDescription: 'Live-Daytrading-Sessions, Echtzeit-Analysen und direkter Austausch – für alle, die den Intraday-Handel systematisch angehen möchten.',
    features: [
      // 'Alle Inhalte aus dem Paket "Cashflow"',
      'Live-Daytrading-Sessions',
      'Echtzeit-Marktanalysen',
      'Intraday-Tradingideen',
      'Direkter Austausch während der Sessions',
      'Aufzeichnungen vergangener Sessions',
      'Individuelles Onboarding damit du dich gleich zurechtfindest',],
    idealFor: 'Erfahrene Trader, die täglich aktiv handeln und von Live-Analysen und Echtzeit-Setups profitieren wollen.'
  },
];

/**
 * Produktfamilien, die auf der Preisseite (/pricing) beworben werden — abgeleitet aus
 * PRICING_PACKAGES, damit ein neues/entferntes Paket automatisch mitzieht. Die Zuordnung
 * Typ → Produktfamilie kommt aus den Backend-Produkten, deshalb erst zur Laufzeit.
 */
export function getAdvertisedProductTypes(products: SubscriptionPriceProduct[]): SubscriptionProductType[] {
  const advertisedTypes = new Set(PRICING_PACKAGES.map(config => config.type));
  const productTypes = products.flatMap(p =>
    advertisedTypes.has(p.type) && p.productType !== null ? [p.productType] : []
  );
  return Array.from(new Set(productTypes));
}

/**
 * Trading Boost — wird nicht im Campus verkauft, sondern nur beworben. Der Einstieg
 * läuft über ein Bewerbungsverfahren auf svenbolz.com, deshalb gibt es weder einen
 * SubscriptionType noch eine Laufzeit; die Karte verlinkt ausschließlich nach extern.
 * Inhalte gespiegelt von https://www.svenbolz.com/tradingboost
 */
export interface BoostPackageConfig {
  name: string;
  subtitle: string;
  shortDescription: string;
  features: string[];
  idealFor: string;
}

export const BOOST_URL = 'https://www.svenbolz.com/tradingboost';

export const BOOST_PACKAGE: BoostPackageConfig = {
  name: 'Trading Boost',
  subtitle: 'Näher an den Märkten, näher an Sven!',
  shortDescription: 'Das Zusatzprogramm für die 100K-Community – kein neues Regelwerk, sondern Sparring, Reflexion und ein erweitertes Spielfeld für dein bestehendes System.',
  features: [
    '2x monatlich Deep-Dive Live-Calls (Marktchancen, Timing, Makrobetrachtung)',
    'VIP-Discord-Kanal mit täglichem Daytrading (15:30–16:30 Uhr)',
    'Direkter Kontakt zu Sven Bolz',
    'Optionen & Stillhalterstrategien',
    'Hebelprodukte regelbasiert',
    'Intraday- & Swing-Trades außerhalb des Regelwerks',
    'Krypto-Chancen strategisch eingeordnet',
  ],
  idealFor: 'Aktive 100K-Community-Mitglieder, die mehr als zwei Stunden pro Woche investieren, Entscheidungen mit mehr Klarheit treffen und ihr Trading mental wie strategisch weiterentwickeln wollen.',
};

// Daytrading-specific pricing packages (separate from main pricing page)
export const DAYTRADING_PRICING_PACKAGES: PackageConfig[] = [
  {
    type: 'DAYTRADING_1M',
    period: '1m',
    name: 'Daytrading',
    subtitle: 'Live Daytrading Sessions mit einem erfahrenen Trader.',
    shortDescription: 'Nimm live an professionellen Daytrading-Sessions teil – mit Echtzeit-Tradingideen, Kommentar und nachvollziehbarer Performance.',
    features: [
      'Teilnahme an allen Live Daytrading Sessions',
      'Echtzeit-Tradingideen mit Ein- und Ausstiegen',
      'Live-Stream mit Kommentar und Analyse',
      'Nachvollziehbare Session-Historien',
      'Zugang zu allen Campus-Tools',
      'Individuelles Onboarding damit du dich gleich zurechtfindest',],
    idealFor: 'Aktive Trader, die von Live-Sessions profitieren und ihre Daytrading-Fähigkeiten ausbauen wollen.',
  },
  {
    type: 'DAYTRADING_6M',
    period: '6m',
    name: 'Daytrading',
    subtitle: 'Live Daytrading Sessions mit einem erfahrenen Trader.',
    shortDescription: 'Nimm live an professionellen Daytrading-Sessions teil – mit Echtzeit-Tradingideen, Kommentar und nachvollziehbarer Performance.',
    features: [
      'Teilnahme an allen Live Daytrading Sessions',
      'Echtzeit-Tradingideen mit Ein- und Ausstiegen',
      'Live-Stream mit Kommentar und Analyse',
      'Nachvollziehbare Session-Historien',
      'Zugang zu allen Campus-Tools',
      'Individuelles Onboarding damit du dich gleich zurechtfindest',],
    idealFor: 'Aktive Trader, die von Live-Sessions profitieren und ihre Daytrading-Fähigkeiten ausbauen wollen.',
  },
];
